<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p11
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p11" title="mthfr-p11">
    <img-card>
      <div slot="title" style="width:100%;">{{$t('Mthfr.P11_Title')}}</div>
      <div class="content">
        <div class="box">
          <img src="../../../assets/images/mthfr/p11-1.png">
          <div class="info">
            <div>{{$t('Mthfr.P11_1')}}</div>
            <div>{{$t('Mthfr.P11_2')}}</div>
            <div>{{$t('Mthfr.P11_3')}}</div>
            <div>{{$t('Mthfr.P11_4')}}</div>
          </div>
        </div>
        <div class="box">
          <img src="../../../assets/images/mthfr/p11-2.png">
          <div class="info">
            <div>{{$t('Mthfr.P11_5')}}</div>
            <div>{{$t('Mthfr.P11_6')}}</div>
            <div>{{$t('Mthfr.P11_7')}}</div>
            <div>{{$t('Mthfr.P11_8')}}</div>
          </div>
        </div>
      </div>
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p11",
    components: {ImgCard}
  }
</script>

<style scoped lang="scss">
  .v-mthfr-p11 {
    background-color: rgba(251, 207, 192, 0.2);
    .content {
      display: flex;
      align-items: center;
      justify-content: center;

      .box {
        &:first-child{
            margin-right: 120px;
        }
        display: flex;

        img {
          width: 120px;
          height: 325px;
        }

        .info {
          margin-top: 6px;
          font-size: 16px;
          padding-left: 30px;
          letter-spacing: -0.2px;
          color: #010101;
          &>div{
            margin-bottom: 51px;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p11.vue